import { config as envConfig } from 'env_def';
import moment from 'moment';
import lodashDebounce from 'lodash/debounce';
import { TimeUnit, ReminderAction, } from '../../../api/logical/catalog';
import { apis, inWindow } from '../../../config';
import { api } from '../../../api/api';
import { util } from '../../../api/util/index';
import { locationHelper } from '@/api/util/location_helper';
import { getIn18Text } from '@/api/utils';
let ZONE_LIST = [];
const Tag = '[Catalog]';
const NOTICE_INTERVAL_OFFSET = 2 * 60 * 60 * 1000;
const NOTICE_EXPIRE_OFFSET = 24 * 60 * 60 * 1000;
class CatalogApiImpl {
    constructor() {
        this.urlMap = {
            create: '/lingxi/calender/create',
            import: '/lingxi/calender/port',
            config: '/lingxi/calender/edit/',
            add_caldav: '/lingxi/calender/third/1',
            add_exchange: '/lingxi/calender/third/2',
            subscribe: '',
        };
        this.initData = {
            catalog: [],
            schedule: [],
            noticeObjMap: {},
            noticeTimeoutHandler: [],
            enableNotice: true,
        };
        this.scheduleUrl = envConfig('scheduleJumpUrlBase');
        this.scheduleEnUrl = envConfig('scheduleJumpUrlBaseEn');
        this.dbName = 'catalog_dexie';
        this.name = apis.catalogApiImpl;
        this.systemApi = api.getSystemApi();
        this.eventApi = api.getEventApi();
        this.DBApi = api.getNewDBApi();
        this.http = api.getDataTransApi();
        this.initCatalogData = this.initCatalogData.bind(this);
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.performanceApi = api.requireLogicalApi(apis.performanceImpl);
        this.initScheduleNotice = lodashDebounce(this.initScheduleNotice, 5000);
        this._debounceCheckExpireScheduleNotice = lodashDebounce(this.checkExpireScheduleNotice.bind(this), 10000, { leading: true, trailing: false });
    }
    _debounceCheckExpireScheduleNotice() {
    }
    async doUpdateSettings(params) {
        const { data } = await this.http.post(this.systemApi.getUrl('updateSetting'), params, { contentType: 'json' });
        return (data === null || data === void 0 ? void 0 : data.data) === 1;
    }
    async doGetSetting() {
        const { data } = await this.http.get(this.systemApi.getUrl('getSetting'));
        if ((data === null || data === void 0 ? void 0 : data.success) || (data === null || data === void 0 ? void 0 : data.code) === 200) {
            return data.data;
        }
        return Promise.reject(data.message);
    }
    async doGetHasMeetingRoom() {
        const { data } = await this.http.get(this.systemApi.getUrl('hasMeetingRoom'));
        return (data === null || data === void 0 ? void 0 : data.success) && data.data;
    }
    async doGetMeetingRoomCondition() {
        const { data } = await this.http.get(this.systemApi.getUrl('meetingRoomCondition'));
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(data.message);
    }
    async doGetMeetingRoomList(condition) {
        const zone_id = await this.getZoneId();
        const unit = 15;
        condition = Object.assign(Object.assign({ unit }, condition), { zone_id });
        const { data } = await this.http.get(this.systemApi.getUrl('meetingRoomList'), condition);
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data.itemList;
        }
        return Promise.reject(data.message);
    }
    async doGetMeetingRoomDetail(condition) {
        const zone_id = await this.getZoneId();
        const unit = 15;
        condition = Object.assign(Object.assign({ unit }, condition), { zone_id });
        const { data } = await this.http.get(this.systemApi.getUrl('meetingRoomDetail'), condition);
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(data.message);
    }
    async doGetAvailableRoom(condition) {
        const unit = 15;
        condition = Object.assign({ unit }, condition);
        const { data: res = {} } = await this.http.post(this.systemApi.getUrl('meetingRoomAvailable'), condition, { contentType: 'json' });
        const { data = { roomInfoList: [] } } = res;
        const { roomInfoList = [] } = data;
        return roomInfoList;
    }
    async doGetOneRoomInfo(condition) {
        const unit = 15;
        condition = Object.assign({ unit }, condition);
        const { data: res = {} } = await this.http.post(this.systemApi.getUrl('oneMeetingRoomInfo'), condition, { contentType: 'json' });
        const { data: { statusCode, untilDate }, } = res;
        return { statusCode, untilDate };
    }
    async doGetMeetingRoomReserveConfig() {
        var _a, _b;
        const { data } = await this.http.get(this.systemApi.getUrl('meetingRoomConfig'));
        if (data === null || data === void 0 ? void 0 : data.success) {
            return { maxReserveDuration: (_b = (_a = data.data) === null || _a === void 0 ? void 0 : _a.maxReserveDuration) !== null && _b !== void 0 ? _b : null };
        }
        return Promise.reject(data.message);
    }
    watchLogin(ev) {
        if (ev && ev.eventData) {
            this.DBApi.initDb(this.dbName);
            this.initCatalogData();
        }
        else {
            this.DBApi.closeSpecific(this.dbName);
        }
    }
    getEmail() {
        const user = this.systemApi.getCurrentUser();
        return (user === null || user === void 0 ? void 0 : user.id) || '';
    }
    transCatalogData(data) {
        const email = this.getEmail();
        return data.map(item => {
            const newItem = Object.assign({}, item);
            newItem.isOwner = Number(email === item.belonger.extDesc);
            newItem.id = item.catalogId;
            return newItem;
        });
    }
    thirdTransCatalogData(data) {
        const email = this.getEmail();
        const catalogArr = [];
        data.forEach(thirdAccount => {
            const { appEmail, appType, catalogList, syncAccountId, syncAccountType, userName } = thirdAccount || {};
            if (catalogList && catalogList.length) {
                catalogList.forEach((item) => {
                    const newItem = Object.assign({}, item);
                    newItem.isOwner = Number(email === item.belonger.extDesc);
                    newItem.id = item.catalogId;
                    newItem.syncAccountId = Number(syncAccountId);
                    newItem.thirdAccount = {
                        appEmail,
                        appType,
                        syncAccountId,
                        syncAccountType,
                        userName,
                    };
                    catalogArr.push(newItem);
                });
            }
        });
        return catalogArr;
    }
    publicTransCatalogData(data) {
        return data.map(item => {
            const newItem = Object.assign({}, item);
            newItem.isOwner = 0;
            newItem.id = item.catalogId;
            newItem.sourcePublic = true;
            newItem.status = 5;
            newItem.belonger = Object.assign(Object.assign({}, (newItem.belonger || {})), { extDesc: item.name || '公共日历', extNickname: item.name || '公共日历' });
            return newItem;
        });
    }
    getGMT(item) {
        var _a, _b, _c, _d;
        let gmt = 'GMT+08:00';
        const zoneId = ((_b = (_a = item === null || item === void 0 ? void 0 : item.time) === null || _a === void 0 ? void 0 : _a.startZone) === null || _b === void 0 ? void 0 : _b.id) || ((_d = (_c = item === null || item === void 0 ? void 0 : item.time) === null || _c === void 0 ? void 0 : _c.endZone) === null || _d === void 0 ? void 0 : _d.id) || (item === null || item === void 0 ? void 0 : item.startZoneId) || (item === null || item === void 0 ? void 0 : item.endZoneId) || 290;
        if (!item.allDay) {
            if (ZONE_LIST && ZONE_LIST.length) {
                const zone = ZONE_LIST.find(i => i.id === zoneId);
                if (zone) {
                    const reg = /\((.+?)\)/gi;
                    const arr = zone.content.match(reg);
                    if (arr && arr.length) {
                        gmt = arr[0].replace('(', '').replace(')', '');
                        if (gmt === 'GMTZ') {
                            gmt = 'GMT+00:00';
                        }
                    }
                }
            }
        }
        return gmt;
    }
    async transScheduleData(data, isDetail) {
        this.performanceApi.time({
            statKey: 'schedule_data_handle',
            statSubKey: 'data_transform',
        });
        const list = util.singleToList(data);
        let scheduleContact = [];
        const localZoneId = await this.getZoneId();
        const schedule = list.map(item => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (!item)
                return item;
            let newItem = Object.assign({}, item);
            if (isDetail) {
                newItem = Object.assign(newItem, item.time);
                if (newItem.recur) {
                    newItem.recur.userFreq = newItem.recur.userFrequency;
                    newItem.recur.freq = newItem.recur.frequency;
                    delete newItem.recur.userFrequency;
                    delete newItem.recur.frequency;
                }
            }
            const uid = util.getUnique(item.scheduleId, item.catalogId, item.recurrenceId || 0);
            const zoneId = ((_b = (_a = item === null || item === void 0 ? void 0 : item.time) === null || _a === void 0 ? void 0 : _a.startZone) === null || _b === void 0 ? void 0 : _b.id) || ((_d = (_c = item === null || item === void 0 ? void 0 : item.time) === null || _c === void 0 ? void 0 : _c.endZone) === null || _d === void 0 ? void 0 : _d.id) || (item === null || item === void 0 ? void 0 : item.startZoneId) || (item === null || item === void 0 ? void 0 : item.endZoneId) || 290;
            newItem.id = uid;
            if (newItem.allDay || zoneId === localZoneId) {
                newItem.start = util.getTime(((_e = newItem === null || newItem === void 0 ? void 0 : newItem.time) === null || _e === void 0 ? void 0 : _e.start) || newItem.start);
                newItem.end = util.getTime(((_f = newItem === null || newItem === void 0 ? void 0 : newItem.time) === null || _f === void 0 ? void 0 : _f.end) || newItem.end);
            }
            else {
                const gmt = this.getGMT(newItem);
                newItem.start = util.getTimeByGMT(newItem.time.start, gmt);
                newItem.end = util.getTimeByGMT(newItem.time.end, gmt);
            }
            newItem.timeFlag = newItem.start + 86400000 >= newItem.end ? 0 : 1;
            scheduleContact = scheduleContact.concat(CatalogApiImpl.setScheduleContactData(item, uid));
            delete newItem.invitees;
            const attachments = ((_g = item === null || item === void 0 ? void 0 : item.attachments) === null || _g === void 0 ? void 0 : _g.map((f) => {
                var _a;
                f.accountAttachmentAccountId = (_a = f === null || f === void 0 ? void 0 : f.belonger) === null || _a === void 0 ? void 0 : _a.accountId;
                return f;
            })) || [];
            newItem.attachments = attachments;
            return newItem;
        });
        this.performanceApi.timeEnd({
            statKey: 'schedule_data_handle',
            statSubKey: 'data_transform',
            params: {
                event_count: `${schedule.length}`,
            },
        });
        return {
            schedule: schedule,
            scheduleContact,
        };
    }
    async deleteDiffScheduleContact(scheduleList, newlist) {
        var _a;
        const oldList = await this.getScheduleContactById(scheduleList.map(item => item.id));
        const diffRes = util.getDiff(util.getKeyListByList(oldList, 'id'), util.getKeyListByList(newlist, 'id'));
        if ((_a = diffRes.deleteDiff) === null || _a === void 0 ? void 0 : _a.length) {
            this.DBApi.deleteById({
                dbName: this.dbName,
                tableName: 'scheduleContact',
            }, diffRes.deleteDiff);
        }
    }
    static setScheduleContactData(obj, uid) {
        let myself;
        const owner = obj.belonger;
        const creator = obj.creator || owner;
        const organizer = obj.organizer || creator;
        let list = [];
        if (obj === null || obj === void 0 ? void 0 : obj.invitees) {
            list = obj.invitees.map((item) => {
                if (item.invitee && !item.invitee.extDesc) {
                    console.warn('ScheduleContact', item, obj);
                }
                const email = item.invitee.extDesc || '';
                const isOrganizer = email === organizer.extDesc;
                const isOwner = email === owner.extDesc;
                const isCreator = email === creator.extDesc;
                const isInviter = !isOrganizer;
                if (isOrganizer) {
                    myself = isOrganizer;
                }
                return {
                    id: util.getUnique(item.invitee.accountId, uid),
                    contactId: item.invitee.accountId,
                    email,
                    scheduleId: uid,
                    partStat: item.partStat,
                    isOwner: Number(isOwner),
                    isOrganizer: Number(isOrganizer),
                    isCreator: Number(isCreator),
                    isInviter: Number(isInviter),
                    simpleInfo: item.invitee,
                    originInvtees: true,
                };
            });
        }
        if (!myself) {
            myself = organizer;
            list.unshift({
                id: util.getUnique(myself.accountId, uid),
                contactId: myself.accountId,
                email: myself.extDesc,
                scheduleId: uid,
                partStat: obj.partStat,
                isOwner: Number(myself.extDesc === owner.extDesc),
                isOrganizer: Number(myself.extDesc === organizer.extDesc),
                isCreator: Number(myself.extDesc === creator.extDesc),
                isInviter: Number(obj.inviteeType === 2),
                simpleInfo: myself,
            });
        }
        return list;
    }
    async getScheduleContactById(idList) {
        const ids = [...new Set(idList)];
        const res = await this.DBApi.getByRangeCondition({
            dbName: this.dbName,
            tableName: 'scheduleContact',
            adCondition: {
                type: 'anyOf',
                field: 'scheduleId',
                args: [ids],
            },
        });
        return res;
    }
    getSid() {
        const currentUser = this.systemApi.getCurrentUser();
        return currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId;
    }
    buildRequestUrl(url, params) {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        let searchParams = params || {};
        if (isCorpMail) {
            searchParams = Object.assign(Object.assign({}, (params || {})), { sid: this.getSid() });
        }
        return this.http.buildUrl(url, searchParams);
    }
    async getSelfCatalogList() {
        const email = this.getEmail();
        let res;
        try {
            const requestUrl = this.buildRequestUrl(this.systemApi.getUrl('catalogList'));
            const { data } = await this.http.post(requestUrl, {
                uid: email,
                searchTime: new Date().getTime(),
            }, { contentType: 'form' });
            const catalogData = this.transCatalogData(data.data);
            res = {
                success: true,
                data: catalogData === null || catalogData === void 0 ? void 0 : catalogData.filter(item => item.isOwner),
            };
        }
        catch (message) {
            console.error(Tag, 'syncCatalog error', message, this.DBApi);
            res = {
                success: false,
                message,
            };
        }
        return res;
    }
    async syncCatalog() {
        var _a, _b, _c;
        const email = this.getEmail();
        let res;
        try {
            const requestUrl = this.buildRequestUrl(this.systemApi.getUrl('catalogList'));
            const promise1 = this.http.post(requestUrl, {
                uid: email,
                searchTime: new Date().getTime(),
            }, { contentType: 'form' });
            const thirdRequestUrl = this.buildRequestUrl(this.systemApi.getUrl('thirdCatalogList'));
            const promise2 = this.http.post(thirdRequestUrl, {
                uid: email,
                searchTime: new Date().getTime(),
            }, { contentType: 'form' });
            const publicRequestUrl = this.buildRequestUrl(this.systemApi.getUrl('publicCatalogList'));
            const promise3 = this.http.post(publicRequestUrl, {
                uid: email,
                searchTime: new Date().getTime(),
                initDefaultPublic: process.env.BUILD_ISEDM ? 1 : 0,
            }, { contentType: 'json' });
            const result = await Promise.allSettled([promise1, promise2, promise3]);
            const data = result[0].status === 'fulfilled' ? (_a = result[0]) === null || _a === void 0 ? void 0 : _a.value.data : { data: [] };
            const thirdData = result[1].status === 'fulfilled' ? (_b = result[1]) === null || _b === void 0 ? void 0 : _b.value.data : { data: [] };
            const publicData = result[2].status === 'fulfilled' ? (_c = result[2]) === null || _c === void 0 ? void 0 : _c.value.data : { data: [] };
            const catalogData = this.transCatalogData((data === null || data === void 0 ? void 0 : data.data) || []);
            const thirdCatalogData = this.thirdTransCatalogData((thirdData === null || thirdData === void 0 ? void 0 : thirdData.data) || []);
            const publicCatalogData = this.publicTransCatalogData((publicData === null || publicData === void 0 ? void 0 : publicData.data) || []);
            res = {
                success: true,
                data: [...catalogData, ...thirdCatalogData, ...publicCatalogData],
            };
        }
        catch (message) {
            console.error('syncCatalog error', message, this.DBApi);
            res = {
                success: false,
                message,
            };
        }
        return res;
    }
    async syncScheduleDetail(catalogId, recurrenceId, scheduleId, uid) {
        const email = this.getEmail();
        let res;
        try {
            let params = {};
            if (uid) {
                params = { uid };
            }
            else {
                params = { catalogId, recurrenceId, scheduleId };
            }
            const url = this.buildRequestUrl(this.systemApi.getUrl('scheduleDetail'), {
                uid: email,
                searchTime: new Date().getTime(),
            });
            const { data } = await this.http.post(url, Object.assign({}, params), { contentType: 'json' });
            if (!ZONE_LIST || !ZONE_LIST.length) {
                await this.getZoneList();
            }
            const scheduleData = await this.transScheduleData(data.data, true);
            res = {
                success: true,
                data: scheduleData,
            };
        }
        catch (message) {
            console.error('syncScheduleDetail', message);
            res = {
                success: false,
            };
        }
        return res;
    }
    static splitDateRange(s, e, pieces = 2) {
        let start = util.getTime(s);
        let end = util.getTime(e);
        if (end < start) {
            const t = start;
            start = end;
            end = t;
        }
        const delta = Math.ceil((end - start) / 86400000 / pieces);
        if (delta > 0) {
            const rangeArr = [];
            let begin = start;
            while (begin < end) {
                const d1 = begin;
                const d2 = begin + 86400000 * delta;
                rangeArr.push([util.getDateTime(d1), util.getDateTime(d2 < end ? d2 : end)]);
                begin = d2;
            }
            return rangeArr;
        }
        return [[[util.getDateTime(start), util.getDateTime(end)]]];
    }
    async syncScheduleList(catalogIds, start, end) {
        var _a;
        this.performanceApi.time({
            statKey: 'schedule_data_handle',
            statSubKey: 'network_fetch',
        });
        if (catalogIds && catalogIds.length === 0) {
            return {
                success: false,
                message: 'catalogIds is empty',
            };
        }
        const email = this.getEmail();
        let res;
        try {
            const url = this.buildRequestUrl(this.systemApi.getUrl('scheduleList'), {
                uid: email,
                searchTime: new Date().getTime(),
            });
            console.time('network requset events data | SCHEDULE_TIME_LOG');
            const results = await Promise.all(CatalogApiImpl.splitDateRange(start, end).map(([s, e]) => this.http.post(url, {
                catalogIds,
                start: s,
                end: e,
            }, { contentType: 'json' })));
            console.timeEnd('network requset events data | SCHEDULE_TIME_LOG');
            const data = results.map(r => { var _a; return ((_a = r.data) === null || _a === void 0 ? void 0 : _a.data) || []; }).flat();
            if (data.length) {
                res = {
                    success: true,
                    data,
                };
            }
            else {
                console.log('[catalog] syncScheduleList data null', results);
                res = {
                    success: true,
                    data: [],
                    message: 'syncScheduleList data is null',
                };
            }
        }
        catch (message) {
            console.error('syncScheduleList', message);
            res = {
                success: false,
                message,
            };
        }
        this.performanceApi.timeEnd({
            statKey: 'schedule_data_handle',
            statSubKey: 'network_fetch',
            params: {
                event_count: `${(_a = res.data) === null || _a === void 0 ? void 0 : _a.length}`,
            },
        });
        return res;
    }
    async getDBCatalogList(idList) {
        let data;
        if (idList) {
            const ids = [...new Set(idList)];
            data = await this.DBApi.getByIds({
                dbName: this.dbName,
                tableName: 'catalog',
            }, ids);
        }
        else {
            data = await this.DBApi.getByEqCondition({
                dbName: this.dbName,
                tableName: 'catalog',
            });
        }
        console.log('getDBCatalogList', data);
        return data;
    }
    async getDBScheduleList(catalogIds, start, end) {
        this.performanceApi.time({
            statKey: 'schedule_data_handle',
            statSubKey: 'read_db',
        });
        const startTime = util.getTime(start);
        const endTime = util.getTime(end);
        const mStart = moment(startTime);
        const mEnd = moment(endTime);
        let res;
        try {
            const result = await Promise.all([
                this.DBApi.getByRangeCondition({
                    dbName: this.dbName,
                    tableName: 'schedule',
                    adCondition: {
                        type: 'between',
                        field: ['timeFlag', 'start'],
                        args: [[0, startTime - 86400000], [0, endTime], true, true],
                    },
                }),
                this.DBApi.getByRangeCondition({
                    dbName: this.dbName,
                    tableName: 'schedule',
                    adCondition: {
                        type: 'between',
                        field: ['timeFlag', 'start'],
                        args: [[1, -Number.MAX_VALUE], [1, Number.MAX_VALUE], false, false],
                    },
                }),
            ]);
            res = result.flat().filter(i => catalogIds.includes(i.catalogId) && !!util.rangeInteract([mStart, mEnd], [moment(i.start), moment(i.end)]));
        }
        catch (err) {
            console.error('getDBScheduleList Error', err);
            throw err;
        }
        this.performanceApi.timeEnd({
            statKey: 'schedule_data_handle',
            statSubKey: 'read_db',
            params: {
                event_count: `${res.length}`,
            },
        });
        return res;
    }
    async delDBData(dbList, syncList, diffKey, tableName) {
        const oldList = util.getKeyListByList(dbList, diffKey);
        const newList = util.getKeyListByList(syncList, diffKey);
        const diffRes = util.getDiff(oldList, newList);
        if (diffRes.deleteDiff) {
            await this.DBApi.deleteById({
                dbName: this.dbName,
                tableName,
            }, diffRes.deleteDiff);
        }
        return diffRes;
    }
    async doGetCatalogByItem(idList, cached = true) {
        let dbList = [];
        if (cached) {
            dbList = (await this.getDBCatalogList(idList));
            setTimeout(() => {
                this.compareCatalogList(dbList, [], cached);
            }, 0);
        }
        else {
            const syncRes = await this.syncCatalog();
            console.info('[catalog] doGetCatalogByItem server data:', syncRes);
            if (syncRes.success) {
                setTimeout(() => {
                    this.compareCatalogList([], syncRes.data, cached);
                }, 0);
                return syncRes.data;
            }
            dbList = (await this.getDBCatalogList(idList));
            console.error('[catalog] doGetCatalogByItem Error', syncRes.message);
            return dbList;
        }
        return dbList;
    }
    async compareCatalogList(DBCatalogList, netCatalogList, cached) {
        if (cached) {
            const netListRes = await this.syncCatalog();
            if (netListRes.success) {
                await this.DBApi.putAll({ dbName: this.dbName, tableName: 'catalog' }, netListRes.data);
                await this.delDBData(DBCatalogList, netListRes.data, 'id', 'catalog');
                const hasCatalogDiff = this.isDiffCatalogListFn(DBCatalogList, netListRes.data);
                if (hasCatalogDiff) {
                    this.sendNotify({
                        catalog: {
                            hasDiff: hasCatalogDiff,
                        },
                    });
                }
            }
        }
        else {
            const dbList = await this.getDBCatalogList();
            this.DBApi.putAll({ dbName: this.dbName, tableName: 'catalog' }, netCatalogList);
            this.delDBData(dbList, netCatalogList, 'id', 'catalog');
        }
    }
    isDiffCatalogListFn(DBCatalogList, netCatalogList) {
        const DBIdList = new Set(DBCatalogList.map(i => i.catalogId));
        const netIdList = new Set(netCatalogList.map(i => i.catalogId));
        let isDiff = DBIdList.size !== netIdList.size;
        if (isDiff) {
            return true;
        }
        DBCatalogList.forEach(item => {
            const netItemArr = netCatalogList.filter(i => item.catalogId === i.catalogId);
            if (!netItemArr.length || item.updateTime !== netItemArr[0].updateTime) {
                isDiff = true;
            }
        });
        return isDiff;
    }
    sendNotify(res) {
        console.log('[catalog] sendNotify', res);
        this.eventApi.sendSysEvent({
            eventName: 'catalogNotify',
            eventData: res,
        });
    }
    async doGetScheduleByDate(catalogIds, start, end, cached = true, needCompare = true, diffNotify = true) {
        let scheduleList = [];
        this.performanceApi.time({
            statKey: 'schedule_data_handle',
            statSubKey: 'summary',
        });
        if (catalogIds && catalogIds.length === 0) {
            return [];
        }
        if (cached) {
            scheduleList = await this.getDBScheduleList(catalogIds, start, end);
            if (needCompare) {
                setTimeout(() => {
                    this.compareScheduleList(scheduleList, {}, cached, catalogIds, start, end, diffNotify);
                }, 0);
            }
        }
        else {
            const syncRes = await this.syncScheduleList(catalogIds, start, end);
            let scheduleData;
            if (syncRes.success) {
                if (!ZONE_LIST || !ZONE_LIST.length) {
                    await this.getZoneList();
                }
                scheduleData = await this.transScheduleData(syncRes.data);
                const mStart = moment(util.getTime(start));
                const mEnd = moment(util.getTime(end));
                scheduleData.schedule.forEach((it) => {
                    if (util.rangeInteract([mStart, mEnd], [moment(it === null || it === void 0 ? void 0 : it.start), moment(it === null || it === void 0 ? void 0 : it.end)])) {
                        scheduleList.push(it);
                    }
                });
                setTimeout(() => {
                    this.compareScheduleList([], scheduleData, cached, catalogIds, start, end, diffNotify);
                }, 0);
            }
            else {
                scheduleList = await this.getDBScheduleList(catalogIds, start, end);
            }
        }
        let result = [];
        if (scheduleList.length) {
            const catalogList = await this.getDBCatalogList();
            result = scheduleList.map(item => ({
                scheduleInfo: item,
                catalogInfo: catalogList.find(i => i.id === item.catalogId),
                contactInfo: [],
            }));
        }
        this.performanceApi.timeEnd({
            statKey: 'schedule_data_handle',
            statSubKey: 'summary',
            params: {
                event_count: `${result.length}`,
            },
        });
        return result;
    }
    async compareScheduleList(DBList, netScheduleData, cached, catalogIds, start, end, sendNotify = true) {
        this.performanceApi.time({
            statKey: 'schedule_data_handle',
            statSubKey: 'sync_db',
        });
        let scheduleData = {
            schedule: [],
            scheduleContact: [],
        };
        let dbList;
        if (cached) {
            dbList = DBList;
            const syncRes = await this.syncScheduleList(catalogIds, start, end);
            if (syncRes.success) {
                if (!ZONE_LIST || !ZONE_LIST.length) {
                    await this.getZoneList();
                }
                scheduleData = await this.transScheduleData(syncRes.data);
            }
            else {
                console.log('[catalog] compareScheduleList failed because NETWORK.ERR.TIMEOUT');
                return;
            }
        }
        else {
            dbList = await this.getDBScheduleList(catalogIds, start, end);
            scheduleData = netScheduleData;
        }
        const mStart = moment(util.getTime(start));
        const mEnd = moment(util.getTime(end));
        const inRangeData = [];
        scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.schedule.forEach((it) => {
            if (util.rangeInteract([mStart, mEnd], [moment(it === null || it === void 0 ? void 0 : it.start), moment(it === null || it === void 0 ? void 0 : it.end)])) {
                inRangeData.push(it);
            }
        });
        const scheduleDiff = await this.delDBData(dbList, inRangeData, 'id', 'schedule');
        await this.DBApi.putAll({
            dbName: this.dbName,
            tableName: 'schedule',
        }, scheduleData.schedule);
        if (cached && sendNotify) {
            const hasScheduleDiff = !!scheduleDiff.insertDiff.length || !!scheduleDiff.deleteDiff.length;
            if (hasScheduleDiff) {
                this.sendNotify({
                    schedule: {
                        hasDiff: hasScheduleDiff,
                        diff: scheduleDiff,
                    },
                });
            }
        }
        setTimeout(() => {
            this.compareScheduleContactList(scheduleData);
        }, 0);
        this.performanceApi.timeEnd({
            statKey: 'schedule_data_handle',
            statSubKey: 'sync_db',
            params: {
                event_count: `${scheduleData.schedule.length}`,
            },
        });
    }
    async compareScheduleContactList(scheduleData) {
        if (scheduleData && scheduleData.scheduleContact) {
            this.DBApi.putAll({
                dbName: this.dbName,
                tableName: 'scheduleContact',
            }, scheduleData.scheduleContact);
        }
    }
    async doGetScheduleDetail(catalogId, recurrenceId, scheduleId) {
        let scheduleInfo;
        let contactInfo;
        const res = await this.syncScheduleDetail(catalogId, recurrenceId, scheduleId);
        if (res.success) {
            scheduleInfo = res.data.schedule;
            contactInfo = res.data.scheduleContact;
            setTimeout(() => {
                this.deleteDiffScheduleContact(res.data.schedule, res.data.scheduleContact);
                this.DBApi.putAll({
                    dbName: this.dbName,
                    tableName: 'schedule',
                }, res.data.schedule);
                this.DBApi.putAll({
                    dbName: this.dbName,
                    tableName: 'scheduleContact',
                }, res.data.scheduleContact);
            }, 0);
        }
        else {
            scheduleInfo = await this.DBApi.getByEqCondition({
                dbName: this.dbName,
                tableName: 'schedule',
                query: {
                    catalogId,
                    scheduleId,
                    recurrenceId,
                },
            });
            contactInfo = await this.getScheduleContactById([scheduleInfo[0].id]);
        }
        const result = await this.getDBCatalogList();
        return [
            {
                scheduleInfo: scheduleInfo[0],
                catalogInfo: result.find(i => i.id === catalogId),
                contactInfo,
            },
        ];
    }
    async doGetScheduleDetailByUid(uid) {
        var _a, _b;
        let scheduleInfo;
        let contactInfo;
        let catalogId;
        const res = await this.syncScheduleDetail(-1, -1, -1, uid);
        if (res.success) {
            scheduleInfo = res.data.schedule;
            contactInfo = res.data.scheduleContact;
            catalogId = (_a = scheduleInfo[0]) === null || _a === void 0 ? void 0 : _a.catalogId;
            setTimeout(() => {
                this.deleteDiffScheduleContact(res.data.schedule, res.data.scheduleContact);
                this.DBApi.putAll({
                    dbName: this.dbName,
                    tableName: 'schedule',
                }, res.data.schedule);
                this.DBApi.putAll({
                    dbName: this.dbName,
                    tableName: 'scheduleContact',
                }, res.data.scheduleContact);
            }, 0);
        }
        const result = await this.getSelfCatalogList();
        return [
            {
                scheduleInfo: scheduleInfo[0],
                catalogInfo: result.success ? (_b = result.data) === null || _b === void 0 ? void 0 : _b.find((i) => i.id === catalogId) : {},
                contactInfo,
            },
        ];
    }
    doInsertSchedule(config) {
        const uid = this.getEmail();
        const url = this.buildRequestUrl(this.systemApi.getUrl('scheduleAdd'), {
            uid,
            searchTime: new Date().getTime(),
        });
        return this.http.post(url, Object.assign(Object.assign({}, config), { riskHitIntercept: true }), { contentType: 'json' }).then(this.handleRiskHitInterrupt.bind(this));
    }
    doUpdateSchedule(config) {
        const uid = this.getEmail();
        let delPath = this.systemApi.getUrl('scheduleUpdate');
        delPath += config.recurrenceId ? '/cycle/' : '/nocycle/';
        delPath += config.isOrganizer ? 'organizer' : 'invitee';
        delete config.isOrganizer;
        const url = this.buildRequestUrl(delPath, {
            uid,
            searchTime: new Date().getTime(),
        });
        return this.http.post(url, Object.assign(Object.assign({}, config), { riskHitIntercept: true }), { contentType: 'json' }).then(this.handleRiskHitInterrupt.bind(this));
    }
    doDeleteSchedule(config) {
        const uid = this.getEmail();
        let delPath = this.systemApi.getUrl('scheduleDelete');
        delPath += config.recurrenceId ? '/cycle/' : '/nocycle/';
        delPath += config.isOrganizer ? 'organizer' : 'invitee';
        delete config.isOrganizer;
        const url = this.buildRequestUrl(delPath, {
            uid,
            searchTime: new Date().getTime(),
        });
        return this.http.post(url, config, { contentType: 'json' }).then(this.handleRiskHitInterrupt.bind(this));
    }
    doOperateSchedule(config) {
        const uid = this.getEmail();
        const url = this.buildRequestUrl(this.systemApi.getUrl('scheduleOperate'), {
            uid,
            searchTime: new Date().getTime(),
        });
        return this.http.post(url, config, { contentType: 'json' });
    }
    init() {
        if (inWindow() && !(this.systemApi.isElectron() && locationHelper.testPathMatch('writeMail'))) {
            this.eventApi.registerSysEventObserver('login', { func: this.watchLogin.bind(this), name: 'catalogLoginOb' });
        }
        return this.name;
    }
    checkExpireScheduleNotice() {
        if (this.systemApi.isMainWindow() && this.systemApi.isElectron()) {
            this.initScheduleNoticeData().then(() => {
                this.initScheduleNoticeEvent();
                this.sendExpireScheduleNotice();
            });
        }
    }
    clearNoticeTimeoutHandler() {
        const { noticeTimeoutHandler } = this.initData;
        console.log(Tag, 'clearNoticeTimeoutHandler', noticeTimeoutHandler);
        noticeTimeoutHandler === null || noticeTimeoutHandler === void 0 ? void 0 : noticeTimeoutHandler.forEach(handler => {
            clearTimeout(handler);
        });
    }
    afterInit() {
        const currentUser = this.systemApi.getCurrentUser();
        console.log(Tag, 'afterInit initCatalogData currentUser', currentUser);
        if (currentUser) {
            this.DBApi.initDb(this.dbName);
            this.initCatalogData().then(() => {
                console.log(Tag, 'afterInit initCatalogData then');
                this.checkExpireScheduleNotice();
            });
            if (inWindow() && this.systemApi.isElectron() && window.electronLib) {
                this.systemApi.addWindowHooks('onLaptopSuspend', () => {
                    this.clearNoticeTimeoutHandler();
                });
                this.systemApi.addWindowHooks('onLockScreen', () => {
                    this.clearNoticeTimeoutHandler();
                });
                this.systemApi.addWindowHooks('onLaptopResume', () => {
                    this.clearNoticeTimeoutHandler();
                    this._debounceCheckExpireScheduleNotice();
                });
                this.systemApi.addWindowHooks('onUnlockScreen', () => {
                    this.clearNoticeTimeoutHandler();
                    this._debounceCheckExpireScheduleNotice();
                });
            }
        }
        return this.name;
    }
    async testDbNoData() {
        let force = true;
        try {
            const data = await Promise.all([
                this.DBApi.getTableCount({
                    dbName: this.dbName,
                    tableName: 'catalog',
                }),
                this.DBApi.getTableCount({
                    dbName: this.dbName,
                    tableName: 'schedule',
                }),
            ]);
            console.log('[catalog] testDbNoData table count catalog,schedule', data);
            force = !data.some(item => item > 0);
        }
        catch (error) {
            console.error('[catalog] testDbNoData table count Error', error);
            force = true;
        }
        return force;
    }
    sendCatalogInitModuleEvent() {
        this.eventApi.sendSysEvent({
            eventName: 'initModule',
            eventStrData: 'catalog',
        });
    }
    async initScheduleNoticeEvent() {
        const { noticeObjMap = {}, enableNotice } = this.initData;
        this.clearNoticeTimeoutHandler();
        const _noticeTimeoutHandler = [];
        const now = Date.now();
        Object.keys(noticeObjMap).forEach(deadline => {
            const noticeTime = Number(deadline);
            if (noticeTime > now && noticeTime - now <= NOTICE_INTERVAL_OFFSET) {
                const noticeList = [...noticeObjMap[noticeTime]];
                const handler = setTimeout(() => {
                    console.log(Tag, 'customNotification called', noticeObjMap[noticeTime], enableNotice);
                    if (enableNotice) {
                        this.systemApi.createWindowWithInitData('scheduleReminder', {
                            eventName: 'customNotification',
                            eventData: {
                                eventType: 'scheduleReminder',
                                reminders: noticeList,
                            },
                        });
                    }
                }, noticeTime - now);
                console.log(Tag, 'customNotification registed', deadline, noticeObjMap[noticeTime], now);
                _noticeTimeoutHandler.push(handler);
                delete noticeObjMap[noticeTime];
            }
        });
        this.initData.noticeTimeoutHandler = _noticeTimeoutHandler;
    }
    getExpireTitleByReminderInfo(info, nowTime) {
        let title = '';
        let timeDiff = 0;
        const { scheduleStartDate, isAllDay } = info;
        const nowTimeSecondes = Math.floor(nowTime / 1000);
        const scheduleStartSecondes = Math.floor(scheduleStartDate / 1000);
        const oneDayTimestamp = 60 * 60 * 24 * 1000;
        let In18Text = ['BEFORENTIMEUNIT', 'BEFOREHOURSMINUTES'];
        if (nowTime > scheduleStartDate) {
            timeDiff = nowTimeSecondes - scheduleStartSecondes;
        }
        else {
            timeDiff = scheduleStartSecondes - nowTimeSecondes;
            In18Text = ['AFTERNTIMEUNIT', 'AFTERHOURSMINUTES'];
        }
        if (isAllDay) {
            if (nowTime > scheduleStartDate) {
                if (nowTime <= scheduleStartDate + oneDayTimestamp) {
                    title = getIn18Text('JINTIAN');
                }
                else {
                    title = getIn18Text(In18Text[0], { how: Math.floor(timeDiff / 60 / 60 / 24), manyTimes: this.getReminderTextByTimeUnit(TimeUnit.DAY) });
                }
            }
            else if (timeDiff <= 60 * 60 * 24) {
                title = getIn18Text('MINGTIAN');
            }
            else {
                title = getIn18Text(In18Text[0], { how: Math.ceil(timeDiff / 60 / 60 / 24), manyTimes: this.getReminderTextByTimeUnit(TimeUnit.DAY) });
            }
        }
        else if (timeDiff < 5) {
            title = getIn18Text('XIANZAI');
        }
        else if (timeDiff < 60) {
            title = getIn18Text(In18Text[0], { how: timeDiff, manyTimes: this.getReminderTextByTimeUnit(TimeUnit.SECONDS) });
        }
        else if (timeDiff < 60 * 60) {
            title = getIn18Text(In18Text[0], { how: Math.floor(timeDiff / 60), manyTimes: this.getReminderTextByTimeUnit(TimeUnit.MIN) });
        }
        else if (timeDiff < 60 * 60 * 24) {
            title = getIn18Text(In18Text[1], { hour: Math.floor(timeDiff / 60 / 60), minutes: Math.floor((timeDiff / 60) % 60) });
        }
        else {
            title = getIn18Text(In18Text[0], { how: Math.ceil(timeDiff / 60 / 60 / 24), manyTimes: this.getReminderTextByTimeUnit(TimeUnit.DAY) });
        }
        return title;
    }
    async sendExpireScheduleNotice() {
        const { noticeObjMap = {}, enableNotice } = this.initData;
        if (!enableNotice || !this.systemApi.isMainWindow() || !this.systemApi.isElectron()) {
            return;
        }
        const now = Date.now();
        let _reminders = [];
        Object.keys(noticeObjMap).forEach(deadline => {
            const noticeTime = Number(deadline);
            if (noticeTime < now && now - noticeTime < NOTICE_EXPIRE_OFFSET) {
                console.log(Tag, 'sendExpireScheduleNotice called', noticeObjMap[noticeTime], enableNotice);
                const reminders = noticeObjMap[noticeTime].map(reminder => {
                    const title = this.getExpireTitleByReminderInfo(reminder, now);
                    return Object.assign(Object.assign({}, reminder), { reminder: title });
                });
                _reminders = _reminders.concat(reminders);
            }
        });
        if (_reminders.length) {
            this.systemApi.createWindowWithInitData('scheduleReminder', {
                eventName: 'customNotification',
                eventData: {
                    eventType: 'scheduleReminder',
                    reminders: _reminders,
                },
            });
        }
    }
    initScheduleNotice(param) {
        if (this.systemApi.isMainWindow()) {
            if (param === null || param === void 0 ? void 0 : param.catalogId) {
                console.log(Tag, 'initScheduleNotice width catalog', param.catalogId);
            }
            this.initScheduleNoticeData().then(() => {
                this.initScheduleNoticeEvent();
            });
        }
    }
    async initCatalogData() {
        if (process.env.BUILD_ISEDM && process.env.NODE_ENV === 'development') {
            this.sendCatalogInitModuleEvent();
            return;
        }
        const isAccountBg = !!(window && window.isAccountBg);
        if (!isAccountBg) {
            const noData = await this.testDbNoData();
            if (noData) {
                const catalog = await this.doGetCatalogByItem([], false);
                const ids = util.getKeyListByList(catalog, 'id', true);
                const time = Date.now();
                const startTime = util.getDateTime(time - 42 * 24 * 60 * 60 * 1000);
                const endTime = util.getDateTime(time + 42 * 24 * 60 * 60 * 1000);
                const schedule = await this.doGetScheduleByDate(ids, startTime, endTime);
                this.initData = Object.assign(Object.assign({}, this.initData), { catalog,
                    schedule });
            }
            if (this.systemApi.isMainWindow()) {
                await this.initScheduleNotice();
                try {
                    this.systemApi.intervalEvent({
                        seq: 0,
                        eventPeriod: 'extLong',
                        id: 'schedule_notice_collector',
                        handler: async () => {
                            console.log(Tag, 'schedule_notice_collector called');
                            await this.initScheduleNotice();
                        },
                    });
                }
                catch (error) {
                    console.error(Tag, 'initScheduleNoticeData error', error);
                }
            }
        }
        this.sendCatalogInitModuleEvent();
    }
    getTimeUnitOffset(value) {
        switch (value) {
            case TimeUnit.DAY:
                return 24 * 60 * 60 * 1000;
            case TimeUnit.MIN:
                return 1 * 60 * 1000;
            case TimeUnit.HOUR:
                return 60 * 60 * 1000;
            case TimeUnit.WEEK:
                return 7 * 24 * 60 * 60 * 1000;
            case TimeUnit.SECONDS:
            default:
                return 0;
        }
    }
    getReminderTextByTimeUnit(value) {
        switch (value) {
            case TimeUnit.DAY:
                return getIn18Text('TIAN');
            case TimeUnit.MIN:
                return getIn18Text('FENZHONG');
            case TimeUnit.HOUR:
                return getIn18Text('XIAOSHI');
            case TimeUnit.WEEK:
                return getIn18Text('XINGQI');
            case TimeUnit.SECONDS:
                return getIn18Text('MIAO');
            default:
                return '';
        }
    }
    getDurationText(daysDiff) {
        switch (daysDiff) {
            case 0:
                return getIn18Text('XIANZAI');
            case 1:
                return getIn18Text('MINGTIAN');
            case 2:
                return getIn18Text('HOUTIAN');
            default:
                return '';
        }
    }
    getReminderText(startTime, value, isAllDay) {
        var _a, _b, _c;
        const startTimeMom = moment(new Date(startTime));
        const reminderDate = moment(new Date(startTime - this.getTimeUnitOffset(value.timeUnit) * value.interval));
        const dayDiff = startTimeMom.diff(reminderDate, 'days');
        let res = '';
        if (isAllDay) {
            reminderDate.set('hours', ((_a = value.time) === null || _a === void 0 ? void 0 : _a.hr) || 0);
            reminderDate.set('seconds', ((_b = value.time) === null || _b === void 0 ? void 0 : _b.sec) || 0);
            reminderDate.set('minutes', ((_c = value.time) === null || _c === void 0 ? void 0 : _c.min) || 0);
        }
        const HHMM = reminderDate.format('HH:mm');
        if (dayDiff > 2) {
            res = getIn18Text('AFTERNTIMEUNIT', { how: dayDiff, manyTimes: getIn18Text('TIAN') });
        }
        else if (dayDiff > 0) {
            res = this.getDurationText(dayDiff) + HHMM;
        }
        else {
            res = isAllDay ? getIn18Text('XIANZAI') : getIn18Text('AFTERNTIMEUNIT', { how: value.interval, manyTimes: this.getReminderTextByTimeUnit(value.timeUnit) });
        }
        return res;
    }
    getReminderDatetime(scheduleStartDate, reminder, isAllDay) {
        var _a, _b, _c;
        const reminderDate = moment(new Date(scheduleStartDate - this.getTimeUnitOffset(reminder.timeUnit) * reminder.interval));
        if (isAllDay) {
            reminderDate.set('hours', ((_a = reminder.time) === null || _a === void 0 ? void 0 : _a.hr) || 0);
            reminderDate.set('seconds', ((_b = reminder.time) === null || _b === void 0 ? void 0 : _b.sec) || 0);
            reminderDate.set('minutes', ((_c = reminder.time) === null || _c === void 0 ? void 0 : _c.min) || 0);
        }
        return reminderDate.toDate().getTime();
    }
    filterNoticeReminder(dbReminder, schedule) {
        var _a;
        const validReminders = [];
        (_a = schedule === null || schedule === void 0 ? void 0 : schedule.reminders) === null || _a === void 0 ? void 0 : _a.forEach(reminder => {
            var _a;
            console.log(Tag, 'reminder list', reminder);
            const deadline = this.getReminderDatetime(schedule.start, reminder, !!schedule.allDay);
            const formatReminder = `${schedule.scheduleId}_${schedule.start}_${deadline}`;
            console.log(Tag, 'filterNoticedReminder formatedReminderInfo formatReminder', formatReminder);
            if (!dbReminder.has(formatReminder) && reminder.reminderAction && reminder.reminderAction !== ReminderAction.EMAIL) {
                validReminders.push({
                    scheduleId: schedule.scheduleId,
                    title: schedule.summary || getIn18Text('WUZHUTI'),
                    reminder: this.getReminderText(schedule.start, reminder, !!schedule.allDay),
                    deadline,
                    scheduleStartDate: schedule.start,
                    scheduleEndDate: schedule.end,
                    isAllDay: !!schedule.allDay,
                    location: schedule.location,
                    creator: ((_a = schedule.organizer) === null || _a === void 0 ? void 0 : _a.extNickname) || '',
                });
            }
        });
        return validReminders;
    }
    async doPutScheduleReminderDB(reminders = []) {
        if (reminders.length) {
            const dbReminders = reminders.map(item => ({
                id: `${item.scheduleId}_${item.scheduleStartDate}_${item.deadline}`,
                start: item.scheduleStartDate,
                scheduleId: item.scheduleId,
                updateTime: Date.now(),
            }));
            await this.DBApi.putAll({ dbName: this.dbName, tableName: 'scheduleReminder' }, dbReminders);
        }
    }
    async doDeleteScheduleReminderDB(scheduleIds) {
        if (scheduleIds.length) {
            await this.DBApi.deleteByByRangeCondition({
                dbName: this.dbName,
                tableName: 'scheduleReminder',
                adCondition: {
                    field: 'scheduleId',
                    args: [scheduleIds],
                    type: 'anyOf',
                },
            });
        }
    }
    async doCompareDBScheduleReminder(reminderSchedule) {
        let noticeList = [];
        if (reminderSchedule === null || reminderSchedule === void 0 ? void 0 : reminderSchedule.length) {
            const dbScheduleMap = new Map();
            const scheduleIds = reminderSchedule.map(item => item.scheduleId);
            const dbScheduleReminder = await this.doGetDBScheduleReminder(scheduleIds);
            dbScheduleReminder.forEach(item => {
                dbScheduleMap.set(item.id, item);
            });
            reminderSchedule.forEach(item => {
                const validReminders = this.filterNoticeReminder(dbScheduleMap, item);
                if (validReminders.length) {
                    noticeList = noticeList.concat(validReminders);
                }
            });
        }
        return noticeList;
    }
    async initScheduleNoticeData() {
        const time = Date.now();
        const startTime = util.getDateTime(time - 1 * 24 * 60 * 60 * 1000);
        const endTime = util.getDateTime(time + 30 * 24 * 60 * 60 * 1000);
        const syncCatalogResult = await this.syncCatalog();
        const settings = await this.doGetSetting();
        const currentUser = this.getEmail();
        let noticeList = [];
        const noticeObjMap = {};
        if (syncCatalogResult.success) {
            if (settings.reminderNotice) {
                const noticeCatalog = syncCatalogResult.data.filter(catalog => {
                    const { isOwner, syncAccountId, sourcePublic, reminderSetting } = catalog;
                    return (isOwner || syncAccountId || sourcePublic) && Boolean(reminderSetting === null || reminderSetting === void 0 ? void 0 : reminderSetting.reminderNotice);
                });
                const ids = util.getKeyListByList(noticeCatalog, 'id', true);
                const schedule = await this.doGetScheduleByDate(ids, startTime, endTime, false, false, false);
                const filteredSchedule = schedule
                    .filter(s => {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const isOwner = ((_b = (_a = s === null || s === void 0 ? void 0 : s.scheduleInfo) === null || _a === void 0 ? void 0 : _a.organizer) === null || _b === void 0 ? void 0 : _b.extDesc) === currentUser;
                    const resStat = (_c = s === null || s === void 0 ? void 0 : s.scheduleInfo) === null || _c === void 0 ? void 0 : _c.partStat;
                    const isInviteeOperaAvailable = resStat === 2 || resStat === 4 || resStat === 1;
                    const isPublicOrThirdSchedule = !!((_d = s === null || s === void 0 ? void 0 : s.catalogInfo) === null || _d === void 0 ? void 0 : _d.sourcePublic) || !!((_e = s === null || s === void 0 ? void 0 : s.catalogInfo) === null || _e === void 0 ? void 0 : _e.syncAccountId);
                    const hasReminders = ((_g = (_f = s === null || s === void 0 ? void 0 : s.scheduleInfo) === null || _f === void 0 ? void 0 : _f.reminders) === null || _g === void 0 ? void 0 : _g.length) > 0;
                    return (isOwner || isInviteeOperaAvailable || isPublicOrThirdSchedule) && hasReminders;
                })
                    .map(item => item.scheduleInfo);
                noticeList = await this.doCompareDBScheduleReminder(filteredSchedule);
                noticeList.forEach(notice => {
                    if (noticeObjMap[notice.deadline]) {
                        const mergedNoticeList = noticeObjMap[notice.deadline];
                        mergedNoticeList.push(notice);
                        noticeObjMap[notice.deadline] = mergedNoticeList;
                    }
                    else {
                        noticeObjMap[notice.deadline] = [notice];
                    }
                });
            }
            console.log(Tag, 'noticeObjMap', noticeObjMap);
            this.initData = Object.assign(Object.assign({}, this.initData), { noticeObjMap, enableNotice: !!settings.reminderNotice });
        }
        else {
            console.error('initScheduleNoticeData failed', 'fetch catalog error');
        }
    }
    async doGetDBScheduleReminder(scheduleIds) {
        const res = await this.DBApi.getByRangeCondition({
            dbName: this.dbName,
            tableName: 'scheduleReminder',
            adCondition: {
                type: 'anyOf',
                field: 'scheduleId',
                args: [scheduleIds],
            },
        });
        return res;
    }
    async doGetSubscribeCatalogByContact(params) {
        const uid = this.getEmail();
        const url = this.buildRequestUrl(this.systemApi.getUrl('getSubscribeCatalogList'), {
            uid,
            searchTime: new Date().getTime(),
        });
        const { data } = await this.http.post(url, params, { contentType: 'json' });
        return this.transCatalogData(data.data);
    }
    async doSubscribeCatalog(params) {
        const uid = this.getEmail();
        const url = this.buildRequestUrl(this.systemApi.getUrl('subscribeCatalog'), {
            uid,
            searchTime: new Date().getTime(),
        });
        const { data } = await this.http.post(url, params, { contentType: 'json' });
        return (data === null || data === void 0 ? void 0 : data.code) === 200;
    }
    async doUnsubscribeCatalog(params) {
        const uid = this.getEmail();
        const url = this.buildRequestUrl(this.systemApi.getUrl('unsubscribeCatalog'), {
            uid,
            searchTime: new Date().getTime(),
        });
        const { data } = await this.http.post(url, params, { contentType: 'json' });
        this.DBApi.deleteById({
            dbName: this.dbName,
            tableName: 'catalog',
        }, params.catalogId);
        return (data === null || data === void 0 ? void 0 : data.code) === 200;
    }
    async doDeleteCatalog(params) {
        const uid = this.getEmail();
        const url = this.buildRequestUrl(this.systemApi.getUrl('deleteCatalog'), {
            uid,
            searchTime: new Date().getTime(),
        });
        const { data } = await this.http.post(url, params, { contentType: 'json' });
        this.DBApi.deleteById({
            dbName: this.dbName,
            tableName: 'catalog',
        }, params.catalogId);
        return (data === null || data === void 0 ? void 0 : data.code) === 200;
    }
    async deleteThirdAccountCatalog(params) {
        const uid = this.getEmail();
        const url = this.buildRequestUrl(this.systemApi.getUrl('deleteThirdAccountCatalog'), {
            uid,
            searchTime: new Date().getTime(),
        });
        const param = { syncAccountId: params.syncAccountId, syncAccountType: params.syncAccountType };
        const { data } = await this.http.post(url, param, { contentType: 'json' });
        this.DBApi.deleteById({
            dbName: this.dbName,
            tableName: 'catalog',
        }, params.catalogIds);
        return (data === null || data === void 0 ? void 0 : data.code) === 200;
    }
    async doDeleteMyCatalog(params) {
        const uid = this.getEmail();
        const url = this.buildRequestUrl(this.systemApi.getUrl('deleteMyCatalog'), {
            uid,
            searchTime: new Date().getTime(),
        });
        const { data } = await this.http.post(url, Object.assign(Object.assign({}, params), { includeEvent: 1 }), { contentType: 'json' });
        if ((data === null || data === void 0 ? void 0 : data.code) === 200) {
            this.DBApi.deleteById({
                dbName: this.dbName,
                tableName: 'catalog',
            }, params.catalogId);
        }
        return [(data === null || data === void 0 ? void 0 : data.code) === 200, data === null || data === void 0 ? void 0 : data.err_msg];
    }
    async doGetFreeBusyList(params) {
        const uid = this.getEmail();
        const url = this.buildRequestUrl(this.systemApi.getUrl('freebusyList'), {
            uid,
            searchTime: new Date().getTime(),
        });
        const { data } = await this.http.post(url, params, { contentType: 'json' });
        if (!ZONE_LIST || !ZONE_LIST.length) {
            await this.getZoneList();
        }
        return this.transFreeBusyData(data === null || data === void 0 ? void 0 : data.data, params);
    }
    async doActionCatalog(key, onAfterClose, calendarId) {
        var _a;
        const targetUrl = this.buildUrl(key, calendarId);
        const jumpableUrl = this.systemApi.getUrl('genMailOnlineJumpURL');
        if (!this.systemApi.isElectron()) {
            const preValiteRes = await this.http.get(jumpableUrl, {
                sid: ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.sessionId) || '',
                module: '',
                hl: 'ZH',
            });
            if (preValiteRes.data && preValiteRes.data.success) {
                const preValiteUrl = preValiteRes.data.data.url.replace(/(&l=).+/, `$1${encodeURIComponent(targetUrl)}`);
                this.systemApi.openNewWindow(preValiteUrl);
            }
            return;
        }
        this.systemApi
            .createWindow({
            type: 'customer',
            url: targetUrl,
            setMainWindowCookie: true,
            setMainLocalStorage: true,
            specifyCookieDomain: '.qiye.163.com',
        })
            .then(res => {
            if (res && res.success && res.winId) {
                this.systemApi.addWindowHookConf({
                    targetWinId: res.winId,
                    hooksName: 'onAfterClose',
                    intercept: false,
                });
                const id = this.eventApi.registerSysEventObserver('electronClosed', {
                    name: 'catalogElectronClosedOb' + res.winId,
                    func: ev => {
                        console.log('[catalog] hook callback ', res, ev);
                        if (ev.eventStrData === String(res.winId)) {
                            onAfterClose();
                            this.eventApi.unregisterSysEventObserver('electronClosed', id);
                        }
                    },
                });
            }
        });
    }
    transFreeBusyData(resData, params) {
        const startTime = util.getTime(params.start);
        const endTime = util.getTime(params.end);
        const list = [];
        if (Array.isArray(resData)) {
            resData.forEach(item => {
                list.push({
                    account: item.account,
                    freeBusyItems: item.freeBusyItems
                        .map((fi) => {
                        let start;
                        let end;
                        if (fi.allDay) {
                            start = util.getTime(fi.start);
                            end = util.getTime(fi.end);
                        }
                        else {
                            const gmt = this.getGMT(fi);
                            start = util.getTimeByGMT(fi.start, gmt);
                            end = util.getTimeByGMT(fi.end, gmt);
                        }
                        return {
                            allDay: fi.allDay,
                            color: fi.color,
                            summary: fi.summary,
                            start,
                            end,
                            uid: fi.uid,
                            scheduleId: fi.scheduleId,
                            instanceId: fi.instanceId,
                            recurrenceId: fi.recurrenceId,
                        };
                    })
                        .filter((fi) => {
                        if (fi.start !== fi.end) {
                            return !(fi.end <= startTime || fi.start >= endTime);
                        }
                        return !(fi.end < startTime || fi.start > endTime);
                    }),
                });
            });
        }
        return list;
    }
    async doGetAllPublicCatalog() {
        const publicRequestUrl = this.buildRequestUrl(this.systemApi.getUrl('allPublicCatalogList'));
        const email = this.getEmail();
        try {
            const { data } = await this.http.post(publicRequestUrl, {
                uid: email,
                searchTime: new Date().getTime(),
            }, { contentType: 'form' });
            const publicCatalogData = this.publicTransCatalogData((data === null || data === void 0 ? void 0 : data.data) || []);
            return publicCatalogData;
        }
        catch (error) {
            console.error('doGetAllPublicCatalog error:', error);
            return Promise.resolve([]);
        }
    }
    async doReminderSettingCatalog(params) {
        const requestUrl = this.buildRequestUrl(this.systemApi.getUrl('reminderSettingCatalog'));
        const email = this.getEmail();
        try {
            const { data } = await this.http.post(requestUrl, Object.assign({ uid: email, searchTime: new Date().getTime() }, params), { contentType: 'json' });
            return (data === null || data === void 0 ? void 0 : data.code) === 200;
        }
        catch (error) {
            console.error('doReminderSettingCatalog error:', error);
            return Promise.resolve(false);
        }
    }
    async getZoneList(noCache = false) {
        const email = this.getEmail();
        let res = [];
        try {
            if (!noCache && ZONE_LIST.length) {
                return ZONE_LIST;
            }
            const requestUrl = this.buildRequestUrl(this.systemApi.getUrl('zoneList'));
            const { data } = await this.http.post(requestUrl, {
                uid: email,
                searchTime: new Date().getTime(),
            }, { contentType: 'form' });
            if ((data === null || data === void 0 ? void 0 : data.data) && (data === null || data === void 0 ? void 0 : data.data.length)) {
                const sysTimeZoneKey = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const sysOffsetTimeSec = moment().utcOffset() * 60;
                res = data.data.map(it => {
                    if (it.key === sysTimeZoneKey && sysOffsetTimeSec !== it.totalSeconds) {
                        const sysOffsetStr = 'GMT' + moment().format('Z');
                        return Object.assign(Object.assign({}, it), { totalSeconds: sysOffsetTimeSec, offset: sysOffsetStr, content: `(${sysOffsetStr}) ${it.content.split(' ')[1]}` });
                    }
                    return it;
                });
            }
        }
        catch (message) {
            console.log('[catalog] getZoneList error', message);
            res = [];
        }
        ZONE_LIST = res;
        return res;
    }
    async getZoneId() {
        const key = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let zoneList = [];
        if (ZONE_LIST && ZONE_LIST.length) {
            zoneList = ZONE_LIST;
        }
        else {
            zoneList = await this.getZoneList();
        }
        if (zoneList.length) {
            const zone = zoneList.find(i => {
                return i.key === key;
            });
            if (zone) {
                return zone.id;
            }
            return 290;
        }
        return 290;
    }
    buildUrl(key, calendarId) {
        const func = this.urlMap[key];
        const hashPart = key === 'config' ? func + calendarId : func;
        const webMailHost = this.mailConfApi.getWebMailHost(true);
        const lang = this.systemApi.getSystemLang();
        const url = lang === 'en' ? this.scheduleEnUrl : this.scheduleUrl;
        return webMailHost + url + hashPart;
    }
    handleRiskHitInterrupt(resp) {
        const { data } = resp;
        const { code, data: result } = data || {};
        if (code !== 200 && (result === null || result === void 0 ? void 0 : result.operation) && (result === null || result === void 0 ? void 0 : result.url)) {
            this.eventApi.sendSysEvent({
                eventName: 'RiskHitInterrupt',
                eventData: {
                    operate: result.operation,
                    url: result.url,
                },
                _account: resp.config._account,
            });
        }
        return resp;
    }
}
const catalogApiImpl = new CatalogApiImpl();
api.registerLogicalApi(catalogApiImpl);
export default catalogApiImpl;
